import queryString from 'query-string';
import { QueryStringKeys } from '../../constants/query-string-keys';
import { UTMSource, UTMMedium } from '../../constants/query-string-values';
import { Routes } from '../../constants/routes';
export const generatePetInsuranceUrlWithQueryParams = (utmTerm: string, utmCampaign: string, utmContent: string) => queryString.stringifyUrl({
  url: Routes.PetInsuranceQuoteLink,
  query: {
    [QueryStringKeys.UTMSource]: UTMSource.Wag,
    [QueryStringKeys.UTMMedium]: UTMMedium.Web,
    [QueryStringKeys.UTMCampaign]: utmCampaign,
    [QueryStringKeys.UTMContent]: utmContent,
    [QueryStringKeys.UTMTerm]: utmTerm
  }
});